import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'ln-movil-menu-svg-icon',
  imports: [NgClass],
  templateUrl: './ln-movil-menu-svg-icon.component.html',
  styleUrl: './ln-movil-menu-svg-icon.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LnMovilMenuSvgIconComponent {
  @Input({ required: true }) class!: string;
}
